import { dictTerms } from "@/mocks/melon";

export default function Dict() {
  return (
    <section id="dict" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 text-xs font-bold tracking-widest text-accent-600">瓜言瓜语 · 小百科</p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">吃瓜词典</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              评论区里那些高频黑话到底啥意思？看完这几个词，轻松看懂热聊现场。
            </p>
          </div>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {dictTerms.map((t) => (
            <article key={t.term} className="rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300 hover:bg-accent-50/60">
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className="ri-question-mark text-lg" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-heading text-lg font-bold leading-none text-foreground-950">{t.term}</h3>
                  <p className="mt-1 text-xs text-accent-700">{t.pinyin}</p>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}